import type { ServiceDocument } from '../dto/ServiceDocumentDtos';
import { fetchServiceDocument } from './fetchServiceDocument';
import type { AxiosInstance } from 'axios';

export class ServiceCache {
  promise: Promise<ServiceDocument> | null = null;
  constructor(readonly serviceDocumentUrl: string, private axiosInstance: AxiosInstance) {
  }

  async getServiceDocument() {
    if (this.promise == null) {
      this.promise = fetchServiceDocument(this.serviceDocumentUrl, this.axiosInstance);
    }
    return this.promise;
  }

  startPreload(): void {
    /*
      Ignore error during preloading. Error will be reported on first use
      instead.
    */
    this.getServiceDocument().catch(_ => {});
  }
}
